module.exports = __webpack_public_path__ + "assets/img/李岳彪.66c025cf.png";